// INCOGNITO (Figma 40000891:57079 — 2026-09-15 parity audit A-4, busy-my-web#407).
//
// "Your chats won't be turned into ongoing stories, and the system won't act on them. This space is
// only for testing." A mode, not a page: the header's incognito icon turns it on, Home's centre says
// what it means, the SmartBox wears a dashed border and drops its create pencil (the frame draws it
// with only + and the globe), and nothing said in it is meant to be kept.
//
// THE SERVER HALF IS NOT BUILT. A real incognito needs a do-not-persist flag on the chat/search
// calls so the BFF writes no story and no timeline row (recorded on #407 as the backend need). Until
// that exists this module is honest about what it can do on its own: it is CLIENT-SIDE ONLY, it
// keeps the flag out of storage so it never survives a reload, and it gates the one thing the web
// owns end-to-end — the creation surfaces the box offers, which is where a chat turns into an
// Ongoing. What it must NOT do is claim more than that, which is why `serverEnforced` is false and
// the notice says "only for testing".

import { setIncognitoRequests } from '@/lib/incognitoRequest'

const isOn = (s) => !!s.on

export const state = () => ({
  // Deliberately NOT read from localStorage: a mode that outlives the tab is a mode the user
  // forgets they are in, and this one changes what is kept.
  on: false,
})

export const getters = {
  on: isOn,
  /** Alias for the surfaces that read it as a noun. */
  active: isOn,
  /** Does the BACKEND know about this mode yet? No (see the note above) — surfaces say so. */
  serverEnforced: () => false,
}

export const mutations = {
  SET(s, on) {
    s.on = !!on
    // …and the REQUEST layer is told (busy-main-bff#43, 2026-09-15 parity audit): while the mode is
    // on, every ask / search / chat call carries `X-Busy-Incognito: 1` so the BFF writes no story
    // and no timeline row. Pushed rather than pulled because the axios interceptor cannot import
    // this store without an initialisation cycle — see lib/incognitoRequest.js.
    setIncognitoRequests(s.on)
  },
}

export const actions = {
  toggle({ commit, state: s }) { commit('SET', !s.on) },
  set({ commit }, on) { commit('SET', !!on) },
  leave({ commit }) { commit('SET', false) },
}
